export const MESSAGE_SOURCE_PANEL = "brick-next-devtools-panel";
export const FRAME_ACTIVE_CHANGE = "devtools-frame-active-change";
export const PANEL_CHANGE = "devtools-panel-change";
let frameIsActive = true;
let selectedPanel;
export function devtoolsHookEmit(type, payload) {
  const devtools = getDevHook();
  if (!devtools || type === "evaluation" && !(frameIsActive && (!selectedPanel || selectedPanel === "Evaluations"))) {
    // Ignore messages if current devtools panel is not relevant.
    return;
  }
  const emit = () => {
    var _devtools$emit;
    (_devtools$emit = devtools.emit) === null || _devtools$emit === void 0 || _devtools$emit.call(devtools, {
      type,
      payload
    });
  };

  // Try to emit only in idle time.
  // istanbul ignore next
  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(emit);
  } else {
    setTimeout(emit, 0);
  }
}
export function listenDevtoolsEagerly() {
  window.addEventListener("message", _ref => {
    let {
      data
    } = _ref;
    if ((data === null || data === void 0 ? void 0 : data.source) !== MESSAGE_SOURCE_PANEL) {
      return;
    }
    const payload = data.payload;
    switch (payload === null || payload === void 0 ? void 0 : payload.type) {
      case FRAME_ACTIVE_CHANGE:
        {
          frameIsActive = payload.active;
          break;
        }
      case PANEL_CHANGE:
        {
          selectedPanel = payload.panel;
          break;
        }
    }
  });
}
export function getDevHook() {
  return window.__BRICK_NEXT_DEVTOOLS_HOOK__;
}
//# sourceMappingURL=devtools.js.map